import React from 'react';
import PropTypes from 'prop-types';

const PlanType = ({ type, buttonTitle, planTitle, handlePlan }) => (
  <div className="plan-type">
    {type === 'free' && (
      <div className="plan-type-content">
        <div>
          <div>
            <div className="plan">Free</div>
            <div className="price">$0</div>
            <div className="desc text-left">
              Create unlimited copyright split sheets with your collaborators -
              simple one page agreements that can cover all of your content
              (videos, music, literature, images).
            </div>
          </div>
          <br />
          <ul className="text-left">
            <li>
              <br />
              Establish the percentage of your copyrights that each collaborator
              owns.
            </li>
            <li>
              Build, negotiate, and e-sign your split sheets with your
              collaborators with Cosynd's easy step-by-step process .
            </li>
            <li>Add new titles to your existing split sheets at any time.</li>
          </ul>
        </div>
        <button onClick={() => handlePlan('free')}>{buttonTitle}</button>
      </div>
    )}

    {type === 'premium' && (
      <div className="plan-type-content">
        <div>
          <div>
            <div className="plan">Premium</div>
            <div className="price">{planTitle}</div>
            <div className="desc text-left">
              Build, negotiate, and e-sign various copyright agreements with
              Cosynd's easy step-by-step process. File 4 U.S. Copyright Office
              applications for FREE (just pay federal filing fees).
            </div>
          </div>
          <br />
          <ul className="text-left">
            <li>
              <br />
              File up to 4 free U.S. Copyright Office applications ($100
              savings, just pay federal filing fees). Includes the preparation,
              review, e-filing, and handling of correspondence with the U.S.
              Copyright Office as needed.
            </li>
            <li>
              Create unlimited collaboration agreements that state the ownership
              of your copyrights, who can sell/license them and more in your own
              collaborative workspace.
            </li>
            <li>Create unlimited work for hire agreements.</li>
            <li>Create unlimited music producer agreements.</li>
            <li>
              Add new titles to your agreements at any time and manage less
              paperwork.
            </li>
            <li>
              Decide how and when royalties are paid and how your name/brand can
              be used for premium agreements.
            </li>
            <li>
              Decide what options and rights you and your collaborators will
              have if problems arise.
            </li>
          </ul>
        </div>
        <button onClick={() => handlePlan('premium')}>{buttonTitle}</button>
      </div>
    )}
  </div>
);

PlanType.defaultProps = {
  buttonTitle: 'Select Plan',
};

PlanType.propTypes = {
  buttonTitle: PropTypes.string,
};

export default PlanType;



// WEBPACK FOOTER //
// src/components/UserPlan/PlanType.jsx